/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ChallengeType } from './ChallengeType';
import {
    ChallengeTypeFromJSON,
    ChallengeTypeFromJSONTyped,
    ChallengeTypeToJSON,
} from './ChallengeType';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
} from './FactorMethod';
import type { OIDCChallengeOptions } from './OIDCChallengeOptions';
import {
    OIDCChallengeOptionsFromJSON,
    OIDCChallengeOptionsFromJSONTyped,
    OIDCChallengeOptionsToJSON,
} from './OIDCChallengeOptions';

/**
 * 
 * @export
 * @interface OIDCChallenge
 */
export interface OIDCChallenge {
    /**
     * 
     * @type {string}
     * @memberof OIDCChallenge
     */
    id: string;
    /**
     * 
     * @type {ChallengeType}
     * @memberof OIDCChallenge
     */
    type: ChallengeType;
    /**
     * 
     * @type {FactorMethod}
     * @memberof OIDCChallenge
     */
    authentication_method: FactorMethod;
    /**
     * 
     * @type {OIDCChallengeOptions}
     * @memberof OIDCChallenge
     */
    options: OIDCChallengeOptions;
}

/**
 * Check if a given object implements the OIDCChallenge interface.
 */
export function instanceOfOIDCChallenge(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "authentication_method" in value;
    isInstance = isInstance && "options" in value;

    return isInstance;
}

export function OIDCChallengeFromJSON(json: any): OIDCChallenge {
    return OIDCChallengeFromJSONTyped(json, false);
}

export function OIDCChallengeFromJSONTyped(json: any, ignoreDiscriminator: boolean): OIDCChallenge {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': ChallengeTypeFromJSON(json['type']),
        'authentication_method': FactorMethodFromJSON(json['authentication_method']),
        'options': OIDCChallengeOptionsFromJSON(json['options']),
    };
}

export function OIDCChallengeToJSON(value?: OIDCChallenge | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'type': ChallengeTypeToJSON(value.type),
        'authentication_method': FactorMethodToJSON(value.authentication_method),
        'options': OIDCChallengeOptionsToJSON(value.options),
    };
}

